// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"b1d5d505","453":"926f0775"}[chunkId] + ".chunk.js";
};